// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a18ce437","239":"9aa80add","455":"e68039d3"}[chunkId] + ".chunk.js";
};